import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useState, useEffect } from "react";

interface CreateDiagramDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (name: string) => void;
}

export function CreateDiagramDialog({ 
  open, 
  onOpenChange, 
  onSave 
}: CreateDiagramDialogProps) {
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [internalOpen, setInternalOpen] = useState(false);
  const [nameError, setNameError] = useState("");

  useEffect(() => {
    if (open) {
      setName("");
      setNameError("");
    }
    setInternalOpen(open);
  }, [open]);

  const validateForm = () => {
    if (!name.trim()) {
      setNameError("O nome é obrigatório");
      return false;
    }
    setNameError("");
    return true;
  };

  const handleSave = async () => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        await onSave(name);
        handleOpenChange(false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleOpenChange = (newOpen: boolean) => {
    if (isLoading) return;
    
    setInternalOpen(newOpen);
    if (!newOpen) {
      setTimeout(() => {
        onOpenChange(false);
      }, 100);
    } else {
      onOpenChange(true);
    }
  };

  return (
    <Dialog open={internalOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Novo Diagrama</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <label htmlFor="new-name" className="text-right">
              Nome
            </label>
            <Input
              id="new-name"
              className="col-span-3"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              disabled={isLoading}
            />
            {nameError && <p className="col-span-4 text-sm text-destructive text-right">{nameError}</p>}
          </div>
        </div>
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => handleOpenChange(false)} 
            type="button"
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button 
            onClick={handleSave} 
            type="button"
            className="bg-[#9b87f5] hover:bg-[#9b87f5]/90"
            disabled={isLoading}
          >
            {isLoading ? "Salvando..." : "Salvar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
